import React, { useState, useEffect, useCallback, useMemo } from "react";
import "./styles.css";
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
  Dialog,
  Divider,
  Button,
  IconButton,
  Tooltip,
  styled,
} from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
// import 'react-big-calendar/lib/sass/styles';
import FancyPaper from "../components/FancyPaper";
import { useApp } from "../hooks/useApp";
import {
  createBooking,
  getBookingByWeek,
  getRequestBookingByCompany,
  getRequestBooking,
  reportBookingCapacity,
  bookingApproval,
} from "../services/booking/BookingService";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/es";
import { Controller, useForm } from "react-hook-form";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import RejectBookingModal from "../components/utils/RejectBookingModal";
const TextField = styled(TextValidator)(() => ({
  width: "100%",
}));

const FormHandlerBox = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
  },
}));

// --- Helpers & Types (module scope) ---
type CalendarEvent = {
  id: number | string;
  start: Date;
  end: Date;
  description: string;
  type?: string;
  allDay?: boolean;
  name?: string;
  phone?: string;
  email?: string;
  status?: number;
  spaces?: number | null;
  observations?: string;
  pickUpLocation?: string;
  dropOffLocation?: string;
  airline?: string;
  flightNumber?: string;
  arrivalTime?: string;
  stops?: string[];
  stackIndex?: number;
  areaName?: string;
};

// Convierte la cadena de paradas "A|B|C" en un array ['A','B','C']
const parseStopsToArray = (stopsString: string) => (stopsString ? stopsString.split("|") : []);

// Formatea una hora 'HH:mm' a formato 12 horas con AM/PM, por ejemplo '13:30' -> '1:30 PM'
const formatSingleHourTo12Hour = (time: string) => {
  const [hour, minutes] = time.split(":");
  let formattedHour = parseInt(hour, 10);
  let period = "AM";
  if (formattedHour === 0) formattedHour = 12;
  else if (formattedHour === 12) period = "PM";
  else if (formattedHour > 12) {
    formattedHour -= 12;
    period = "PM";
  }
  return `${formattedHour}:${minutes} ${period}`;
};

const CalendaryPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  // Sincronizamos moment con i18n para que los nombres de días se muestren
  // en el idioma activo. Si la locale no está registrada en moment, se
  // captura el error y se mantiene la configuración por defecto.
  useEffect(() => {
    try {
      moment.locale(i18n.language || "es");
    } catch (e) {
      // Si la locale no existe en moment, no se bloquea la UI.
    }
  }, [i18n.language]);

  // React Big Calendar necesita un `localizer` compatible con moment.
  // No es necesario recrearlo al cambiar el idioma porque llamamos
  // `moment.locale(i18n.language)` en el useEffect más arriba. Mantener
  // el localizer estable evita advertencias de dependencias.
  const localizer = useMemo(() => momentLocalizer(moment), []);
  const { setLoading, setErrorMsg, setSuccessMsg, company, isAdmin, authInfo } =
    useApp();

  const [options, setOptions] = useState<any>([]);
  const [selectedCategory, setSelectedCategory] = useState<any>("");
  const [bookingData, setBookingData] = useState<any>([]);
  const [allAreaDetails, setAllAreaDetails] = useState<any[]>([]);
  const [subOptions, setSubOptions] = useState<any>([]);
  const [subOptionsGroup, setSubOptionsGroup] = useState<Record<number, number[]>>({});
  const [eventos, setEventos] = useState<CalendarEvent[]>([]);
  const [typeFilter, setTypeFilter] = useState<string>("transportation");
  // temporary arrays used by selection logic
  const typeOptions = [
    { id: "installation", name: t("Instalación") },
    { id: "transportation", name: t("Transporte") },
  ];
  const formats = {
    // Formato del día
    // @ts-ignore
    dayFormat: (date, culture, localizer) => localizer.format(date, "ddd DD"),

    // Formato de la ranura de tiempo en el lado izquierdo del calendario
    // @ts-ignore
    timeGutterFormat: (date, culture, localizer) => {
      const formattedHour = localizer
        .format(date, "HH", culture)
        .padStart(2, "0"); // Añadir ceros a la izquierda si es necesario
      const hour12Format = parseInt(formattedHour, 10) >= 12 ? "PM" : "AM";
      let hour12 = parseInt(formattedHour, 10);
      if (hour12 > 12) {
        hour12 -= 12;
      } else if (hour12 === 0) {
        hour12 = 12;
      }
      return `${hour12.toString().padStart(2, "0")}:00 ${hour12Format}`; // Mostrar solo horas enteras y agregar ceros a la izquierda
    },

    // Formato del rango de tiempo de un evento
    // @ts-ignore
    eventTimeRangeFormat: (formattedRange, culture, localizer) => {
      const startTime = localizer.format(
        formattedRange.start,
        "hh:mm A",
        culture
      );
      const endTime = localizer.format(formattedRange.end, "hh:mm A", culture);
      return `${startTime} - ${endTime}`;
    },
  };
  const [, setData] = useState<any[]>([]);
  const [completeData, setCompleteData] = useState<any>(null);
  const [, setShouldOpenEditorDialog] = useState(false);
  const [, setRejeEvent] = useState({});
  const { setValue, watch, control, getValues } = useForm();
  const [slotReserve, setslotReserve] = useState<any>({});

  // Cuando cambia la `company`, limpiar el calendario para que quede vacío
  useEffect(() => {
    // Limpiar eventos y datos relacionados para evitar mostrar información
    // de la empresa anterior mientras se cargan los nuevos.
    setEventos([]);
    setBookingData([]);
    setOptions([]);
    setSubOptions([]);
    setSelectedCategory("");
    setCompleteData(null);
    try {
      // resetear el campo controlado del formulario que muestra el calendario
      setValue("subOptions", undefined);
    } catch (e) {
      // ignore si setValue no está disponible por alguna razón
    }
  }, [company]);
  
  const [nextWeek, setNextWeek] = useState(moment().week());
  const [nextYear, setNextYear] = useState(moment().year());
  const [showEvent, setShowEvent] = useState({ open: false, event: "" });
  const [openFormReserve, setOpenFormReserve] = useState(false);
  const [bookingTime, setBookingTime] = useState<any>(null);
  const [detailReserve, setDetailReserve] = useState<any>(null);
  
  const [state, setState] = useState<any>({
    name: "",
    description: "",
    spaces: 0,
  });
  const [openModalReject, setOpenModalReject] = useState(false);
  const [idReject, setIdReject] = useState(0);

  const handleReject = (id: number) => {
    setIdReject(id);
    setOpenModalReject(true);
  };

  const handleCloseFormReserve = () => {
    setOpenFormReserve(false);
  };

  const watchSubOptions = watch("subOptions");
  const lang = {
    week: t("week"),
    work_week: t("work_week"),
    day: t("day"),
    month: t("month"),
    previous: t("previous"),
    next: t("next"),
    today: t("today"),
    agenda: t("agenda"),

    // @ts-ignore
    showMore: (total) => `+${total} más`,
  };

  const handleFetchBooking = useCallback(async () => {
    setLoading && setLoading(true);
    setBookingData([]);
    setOptions([]);
    setSubOptions([]);
    setSelectedCategory("");
    setEventos([]);
    setCompleteData(null);
    setAllAreaDetails([]);
    try {
      let bookingDataResponse = await getRequestBookingByCompany(
        isAdmin && company ? company : authInfo.companyId
      );
      let bookingDataResponse2 = await getRequestBooking(
        0,
        "",
        isAdmin && company ? company : authInfo.companyId
      );
      if (bookingDataResponse2) {
        setBookingData(bookingDataResponse2.content);
      }
      const allContent = bookingDataResponse || [];
      setAllAreaDetails(allContent);
      // Filtrar por la categoría seleccionada
      const filteredContent = typeFilter
        ? allContent.filter((item: any) => item.type === typeFilter)
        : allContent;
      // Agrupamos por categoría
      const categoryMap = new Map<string, any>();
      filteredContent.forEach((item: any) => {
        if (!categoryMap.has(item.category)) {
          categoryMap.set(item.category, []);
        }
        categoryMap.get(item.category).push(item);
      });

      const setOptionsData = Array.from(categoryMap.entries()).map(
        ([category, items]) => ({
          value: items[0].area_id,
          label: category,
          subOptions: (() => {
            const map = new Map<string, any[]>();
            items.forEach((subItem: any) => {
              const key = subItem.description || String(subItem.id);
              if (!map.has(key)) map.set(key, []);
              // assert non-null because we just set it when missing
              (map.get(key)!).push(subItem);
            });
            return Array.from(map.entries()).map(([desc, arr]) => ({
              value: arr[0].id,
              label: desc,
              groupIds: arr.map((x: any) => x.id),
            }));
          })(),
        })
      );

      // build a map of representative id -> group ids for quick lookup
      const groupMap: Record<number, number[]> = {};
      setOptionsData.forEach((opt: any) => {
        opt.subOptions.forEach((s: any) => {
          groupMap[s.value] = s.groupIds || [s.value];
        });
      });

      setOptions(setOptionsData);
      setSubOptionsGroup(groupMap);
      setLoading && setLoading(false);
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
    }
  }, [isAdmin, company, authInfo, typeFilter, setLoading, setErrorMsg]);

  const searchBookingByWeek = useCallback(async (id: number) => {
    setLoading && setLoading(true);
    try {
      const groupIds = subOptionsGroup && subOptionsGroup[id] ? subOptionsGroup[id] : [id];


      const searchData = bookingData.find((item: any) =>
        item.areaDetailList.find((subItem: any) => subItem.id === id)
      );

      setBookingTime(searchData?.capacity);
      let completeDataLocal = searchData?.areaDetailList.find(
        (subItem: any) => subItem.id === id
      );

      // Fallback: if the area detail wasn't found in the paginated bookingData,
      // search in the complete list from getRequestBookingByCompany
      if (!completeDataLocal) {
        const fallback = allAreaDetails.find((item: any) => item.id === id);
        if (fallback) {
          completeDataLocal = {
            id: fallback.id,
            idArea: fallback.area_id,
            description: fallback.description,
            startTime: fallback.start_time,
            endTime: fallback.end_time,
            startTimeWeekend: fallback.start_time_weekend || fallback.start_time,
            endTimeWeekend: fallback.end_time_weekend || fallback.end_time,
            publicAmount: fallback.public_amount,
            associatedAmount: fallback.associated_amount,
            capacity: fallback.capacity,
            hasCapacity: fallback.has_capacity === 1,
            details: fallback.details,
            availableDays: fallback.available_days,
          };
        }
      }

      setCompleteData(completeDataLocal);

      const promises = (groupIds || []).map((gid: number) => {
        const payload = { idAreaDetail: gid, week: nextWeek, year: nextYear };
        return getBookingByWeek(isAdmin && company ? company : authInfo.companyId, payload).then((r: any) => r?.days || [] as any[]).catch(() => []);
      });
      const results = await Promise.all(promises);
  let combinedDays: any[] = [];
      results.forEach((arr: any[]) => (combinedDays = combinedDays.concat(arr)));

      const daysById: Record<string | number, any> = {};
      combinedDays.forEach((d: any) => {
        if (!daysById[d.id]) daysById[d.id] = d;
      });
      const bookingDataWeek = { days: Object.values(daysById) };

      const days = (bookingDataWeek.days || []).map((evento: any) => {
        const [sh, sm] = (evento.start || "00:00").split(":").map(Number);
        const [eh, em] = (evento.end || "00:00").split(":").map(Number);
        return {
          id: evento.id,
          start: new Date(
            moment(evento.bookingDate).year(),
            moment(evento.bookingDate).month(),
            moment(evento.bookingDate).date(),
            Number.isFinite(sh) ? sh : 0,
            Number.isFinite(sm) ? sm : 0
          ),
          end: new Date(
            moment(evento.bookingDate).year(),
            moment(evento.bookingDate).month(),
            moment(evento.bookingDate).date(),
            Number.isFinite(eh) ? eh : 0,
            Number.isFinite(em) ? em : 0
          ),
          description:
            evento.description !== null ? evento.description : t("spaceReservation"),
          type: evento.type,
          allDay: evento.allDay,
          name: evento.name,
          phone: evento.phone,
          email: evento.email,
          status: evento.status,
          spaces: evento.spaces,
          observations: evento.observations,
          pickUpLocation: evento.pickUpLocation,
          dropOffLocation: evento.dropOffLocation,
          airline: evento.airline,
          flightNumber: evento.flightNumber,
          arrivalTime: evento.arrivalTime,
          stops: parseStopsToArray(evento.stops || ""),
          stackIndex: 0,
        };
      });

  // Agrupamos los eventos por su timestamp de inicio (same-day & same-time).
  // Esto nos permite detectar colisiones exactas y asignar dos metadatos:
  // - stackIndex: posición del evento dentro del grupo (0..N-1)
  // - stackSize: tamaño total del grupo (N)
  // Estos valores se usan luego para posicionar los eventos lado-a-lado
  // y para mostrar la numeración "X de N" en el renderer.
  // Nota: sólo se consideran colisiones exactas (mismo milisegundo de inicio).
  // Si necesitáramos solapamiento por rango parcial habría que usar otra lógica.
      const startMap: Record<number, any[]> = {};
      days.forEach((d: any) => {
        try {
          const key = d.start.getTime();
          if (!startMap[key]) startMap[key] = [];
          startMap[key].push(d);
        } catch (e) {
          // ignore
        }
      });
      Object.values(startMap).forEach((group) => {
        const size = group.length;
        group.forEach((ev: any, idx: number) => {
          ev.stackIndex = idx;
          ev.stackSize = size;
        });
      });

      setEventos(days);

      setLoading && setLoading(false);
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
    }
  }, [subOptionsGroup, bookingData, allAreaDetails, nextWeek, nextYear, isAdmin, company, authInfo, setLoading, setErrorMsg, t]);

  // Carga todas las reservas de todos los area details (del tipo filtrado) para la semana actual.
  // Se usa cuando no se ha seleccionado un sub-área específica.
  const searchAllBookingsByWeek = useCallback(async (areaDetailsOverride?: any[]) => {
    setLoading && setLoading(true);
    try {
      const details = areaDetailsOverride || allAreaDetails;
      const filteredDetails = typeFilter
        ? details.filter((item: any) => item.type === typeFilter)
        : details;

      const allIds: number[] = filteredDetails.map((item: any) => item.id);
      const uniqueIds = Array.from(new Set(allIds));

      if (uniqueIds.length === 0) {
        setEventos([]);
        setLoading && setLoading(false);
        return;
      }

      // Mapa de areaDetail id -> nombre de categoría para enriquecer los eventos
      const areaNameMap: Record<number, string> = {};
      filteredDetails.forEach((item: any) => {
        areaNameMap[item.id] = item.category || item.description || '';
      });

      const companyId = isAdmin && company ? company : authInfo.companyId;
      const promises = uniqueIds.map((gid: number) => {
        const payload = { idAreaDetail: gid, week: nextWeek, year: nextYear };
        return getBookingByWeek(companyId, payload)
          .then((r: any) =>
            (r?.days || []).map((d: any) => ({ ...d, _areaName: areaNameMap[gid] || '' }))
          )
          .catch(() => []);
      });

      const results = await Promise.all(promises);
      let combinedDays: any[] = [];
      results.forEach((arr: any[]) => (combinedDays = combinedDays.concat(arr)));

      // Deduplicar por id
      const daysById: Record<string | number, any> = {};
      combinedDays.forEach((d: any) => {
        if (!daysById[d.id]) daysById[d.id] = d;
      });

      const days = Object.values(daysById).map((evento: any) => {
        const [sh, sm] = (evento.start || "00:00").split(":").map(Number);
        const [eh, em] = (evento.end || "00:00").split(":").map(Number);
        return {
          id: evento.id,
          start: new Date(
            moment(evento.bookingDate).year(),
            moment(evento.bookingDate).month(),
            moment(evento.bookingDate).date(),
            Number.isFinite(sh) ? sh : 0,
            Number.isFinite(sm) ? sm : 0
          ),
          end: new Date(
            moment(evento.bookingDate).year(),
            moment(evento.bookingDate).month(),
            moment(evento.bookingDate).date(),
            Number.isFinite(eh) ? eh : 0,
            Number.isFinite(em) ? em : 0
          ),
          description:
            evento.description !== null ? evento.description : t("spaceReservation"),
          type: evento.type,
          allDay: evento.allDay,
          name: evento.name,
          phone: evento.phone,
          email: evento.email,
          status: evento.status,
          spaces: evento.spaces,
          observations: evento.observations,
          pickUpLocation: evento.pickUpLocation,
          dropOffLocation: evento.dropOffLocation,
          airline: evento.airline,
          flightNumber: evento.flightNumber,
          arrivalTime: evento.arrivalTime,
          stops: parseStopsToArray(evento.stops || ""),
          areaName: evento._areaName || '',
          stackIndex: 0,
        };
      });

      // Asignar stackIndex/stackSize para eventos superpuestos
      const startMap: Record<number, any[]> = {};
      days.forEach((d: any) => {
        try {
          const key = d.start.getTime();
          if (!startMap[key]) startMap[key] = [];
          startMap[key].push(d);
        } catch (e) {
          // ignore
        }
      });
      Object.values(startMap).forEach((group) => {
        const size = group.length;
        group.forEach((ev: any, idx: number) => {
          ev.stackIndex = idx;
          ev.stackSize = size;
        });
      });

      setEventos(days);
      setLoading && setLoading(false);
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
    }
  }, [allAreaDetails, typeFilter, nextWeek, nextYear, isAdmin, company, authInfo, setLoading, setErrorMsg, t]);

  useEffect(() => {
    handleFetchBooking();
    // searchBookingByWeek(1);
  }, [company, typeFilter, handleFetchBooking]);

  useEffect(() => {
    if (watchSubOptions) {
      searchBookingByWeek(watchSubOptions);
    } else if (allAreaDetails.length > 0) {
      searchAllBookingsByWeek();
    }
  }, [nextWeek, nextYear, company, searchBookingByWeek, searchAllBookingsByWeek, watchSubOptions, allAreaDetails]);

  const onChangeOptions = (e: any) => {
    setSelectedCategory(e.target.value);
    const subOptionsData = options.find(
      (item: any) => item.value === e.target.value
    )?.subOptions;
    setSubOptions(subOptionsData);
    setValue("subOptions", subOptionsData[0].value);
    searchBookingByWeek(subOptionsData[0].value);
  };

  const handleClearFilters = () => {
    setSelectedCategory("");
    setSubOptions([]);
    setValue("subOptions", undefined);
    setCompleteData(null);
    // El useEffect existente detectará que watchSubOptions es undefined
    // y allAreaDetails.length > 0, y llamará searchAllBookingsByWeek()
  };

  useEffect(() => {
    if (watchSubOptions) {
      searchBookingByWeek(watchSubOptions);
    }
  }, [watchSubOptions, company, searchBookingByWeek]);

  const onNavigate = useCallback(
    // @ts-ignore
    (newDate) => {
      setNextWeek(moment(newDate).week());
      setNextYear(moment(newDate).year());
    },
    [setNextWeek, setNextYear]
  );

  // @ts-ignore
  const customDayPropGetter = (date) => {
    for (let index = 0; index < eventos.length; index++) {
      const element = eventos[index];
      // @ts-ignore
      if (element.allDay && element.start.getDay() === date.getDay()) {
        return {
          style: {
            backgroundColor: "#ebebeb",
          },
        };
      }
    }

    if (date < new Date()) {
      return {
        style: {
          backgroundColor: "#ebebeb",
        },
      };
    }
  };

  /**
   * Metodo encargado de crear registro
   * @param data
   */

  // eventPropGetter: calcula estilos inline para cada evento.
  // Cuando hay multiples eventos con el mismo inicio (stackSize>1)
  // los posicionamos lado-a-lado usando porcentajes para el ancho y el left.
  // Ventajas de usar %:
  // - Se adapta al ancho del contenedor del calendario
  // - Evita cálculos de píxeles frágiles entre diferentes resoluciones
  // @ts-ignore
  const eventPropGetter = useCallback((event) => {
    const stackSize = typeof event.stackSize === "number" ? event.stackSize : 1;
    const stackIndex = typeof event.stackIndex === "number" ? event.stackIndex : 0;
    const widthPercent = stackSize > 1 ? Math.floor(100 / stackSize) : 100;
    const leftPercent = stackSize > 1 ? widthPercent * stackIndex : 0;

    const baseStyle: any = stackSize > 1 ? {
      width: `${widthPercent}%`,
      left: `${leftPercent}%`,
      position: 'absolute',
      boxSizing: 'border-box',
      paddingRight: 4,
      zIndex: 100 + stackIndex,
    } : {};

    const color = event.type === 'CO' ? '#01AEEF' : event.type === 'EX' ? '#0A3A7A' : event.type === 'AD' ? '#FFC000' : undefined;

    return { style: { ...(color ? { backgroundColor: color } : {}), ...baseStyle } };
  }, []);

  // EventComponent: renderizado personalizado dentro del bloque del evento.
  // Muestra un badge "X de Y" cuando stackSize>1 y la descripción.
  // Se mantiene simple y compacto para no romper el layout del calendario.
  const EventComponent = ({ event }: any) => {
    const stackSize = typeof event.stackSize === 'number' ? event.stackSize : 1;
    const stackIndex = typeof event.stackIndex === 'number' ? event.stackIndex : 0;
    const showBadge = stackSize > 1;
    const showAreaName = !watchSubOptions && event.areaName;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', boxSizing: 'border-box', gap: 2 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {showBadge && (
            <div style={{ minWidth: 36, height: 18, background: 'rgba(255,255,255,0.15)', color: '#fff', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 600 }}>
              {`${stackIndex + 1} de ${stackSize}`}
            </div>
          )}
          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 12 }}>{event.description}</div>
        </div>
        {showAreaName && (
          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 10, opacity: 0.85, fontStyle: 'italic' }}>
            {event.areaName}
          </div>
        )}
      </div>
    );
  };

  const {
    minday,
    maxDay,
    mindayWeekEnd,
    maxDayWeekEnd,
  } = useMemo(() => {
    // Cuando hay un area detail específico seleccionado, usar sus horarios
    if (completeData) {
      const startTime = completeData.startTime || "00:00";
      const endTime = completeData.endTime || "23:59";
      const startTimeWeekend = completeData.startTimeWeekend || startTime;
      const endTimeWeekend = completeData.endTimeWeekend || endTime;

      return {
        minday: {
          hour: startTime.slice(0, 2),
          minutes: startTime.slice(3),
        },
        maxDay: {
          hours: endTime.slice(0, 2),
          minutes: endTime.slice(3),
        },
        mindayWeekEnd: {
          hours: startTimeWeekend.slice(0, 2),
          minutes: startTimeWeekend.slice(3),
        },
      maxDayWeekEnd: {
        hours: endTimeWeekend.slice(0, 2),
        minutes: endTimeWeekend.slice(3),
      },
    };
    }

    // Modo "ver todos": calcular el rango horario más amplio de todos los area details
    if (allAreaDetails.length > 0) {
      const filtered = typeFilter
        ? allAreaDetails.filter((item: any) => item.type === typeFilter)
        : allAreaDetails;

      let earliestStart = "23:59";
      let latestEnd = "00:00";
      let earliestStartWeekend = "23:59";
      let latestEndWeekend = "00:00";

      filtered.forEach((item: any) => {
        if (item.start_time && item.start_time < earliestStart) earliestStart = item.start_time;
        if (item.end_time && item.end_time > latestEnd) latestEnd = item.end_time;
        const stw = item.start_time_weekend || item.start_time;
        const etw = item.end_time_weekend || item.end_time;
        if (stw && stw < earliestStartWeekend) earliestStartWeekend = stw;
        if (etw && etw > latestEndWeekend) latestEndWeekend = etw;
      });

      if (earliestStart === "23:59") earliestStart = "00:00";
      if (latestEnd === "00:00") latestEnd = "23:59";
      if (earliestStartWeekend === "23:59") earliestStartWeekend = earliestStart;
      if (latestEndWeekend === "00:00") latestEndWeekend = latestEnd;

      return {
        minday: { hour: earliestStart.slice(0, 2), minutes: earliestStart.slice(3) },
        maxDay: { hours: latestEnd.slice(0, 2), minutes: latestEnd.slice(3) },
        mindayWeekEnd: { hours: earliestStartWeekend.slice(0, 2), minutes: earliestStartWeekend.slice(3) },
        maxDayWeekEnd: { hours: latestEndWeekend.slice(0, 2), minutes: latestEndWeekend.slice(3) },
      };
    }

    // Fallback: sin datos, mostrar todo el día
    return {
      minday: { hour: 0, minutes: 0 },
      maxDay: { hours: 23, minutes: 59 },
      mindayWeekEnd: { hours: 0, minutes: 0 },
      maxDayWeekEnd: { hours: 23, minutes: 59 },
    };
  }, [completeData, allAreaDetails, typeFilter]);

  async function handleSelectSlot({ start, end, slots }: any) {
      // Si el tipo de instalación es transporte, no permitir reservar
      if (typeFilter === "transportation") {
        return;
      }

      const selectedDate = moment(start).format("YYYY-MM-DD");

      let localData: any = null; // Variable local para almacenar temporalmente los datos

      if (completeData) {
        try {
          const reportData = await reportBookingCapacity(
            isAdmin && company ? company : authInfo.companyId,
            selectedDate,
            completeData?.idArea,
            bookingTime ? undefined : completeData?.id
          );

          if (reportData) {
            localData = reportData.content; // Almacenar los datos en la variable local
            setData(localData);
          }
        } catch (error) { }
      }

      // Convertir los tiempos seleccionados a cadenas de formato HH:mm
      const selectedStartTime = moment(start).format("HH:mm");
      const selectedEndTime = moment(end).format("HH:mm");

      let adjustedStartTime = selectedStartTime;
      let adjustedEndTime = selectedEndTime;

      // Verificar si el rango seleccionado coincide con algún rango devuelto por el endpoint
      let isInRange = false;
      for (const item of localData || []) {
        const availableTimeStart = item.hourStart;
        const availableTimeEnd = item.hourEnd;

        // Verificar si el rango seleccionado coincide exactamente con el rango actual en 'localData'
        if (
          selectedStartTime === availableTimeStart &&
          selectedEndTime === availableTimeEnd
        ) {
          isInRange = true;
          break;
        }

        // Verificar si el rango seleccionado está dentro de algún rango actual en 'localData'
        else if (
          selectedStartTime >= availableTimeStart &&
          selectedEndTime <= availableTimeEnd
        ) {
          isInRange = true;
          adjustedStartTime = availableTimeStart;
          adjustedEndTime = availableTimeEnd;
          break;
        }
      }

      if (!isInRange) {
        // Crear una lista plana de todos los rangos de horas disponibles
        const availableTimeRanges = [];
        for (const item of localData || []) {
          availableTimeRanges.push({
            start: item.hourStart,
            end: item.hourEnd,
          });
        }

        // Construir la cadena de todos los rangos de horas disponibles
        const validRanges = availableTimeRanges
          .map(
            (range) =>
              `${formatSingleHourTo12Hour(
                range.start
              )}-${formatSingleHourTo12Hour(range.end)}`
          )
          .join(", ");

        // Mostrar el mensaje de alerta con los rangos de horas disponibles
        Swal.fire({
          icon: "error",
          title: `${t("invalidRange")}`,
          text: `${t("validRanges")}: ${validRanges}`,
          confirmButtonColor: "#0A3A7A",
        });

        return;
      }

      // Permitir la selección de slots si el rango seleccionado coincide con algún rango devuelto por el endpoint
      const timeIntervals = [];
      let current = moment(adjustedStartTime, "HH:mm").startOf("hour");
      const endTime = moment(adjustedEndTime, "HH:mm").startOf("hour");

      while (current <= endTime) {
        timeIntervals.push(current.format("HH:mm"));
        current = current.add(30, "minutes");
      }

      setslotReserve({
        date: moment(start).format("DD/MM/YYYY"),
        start: adjustedStartTime,
        end: adjustedEndTime,
        slots: timeIntervals,
        day: moment(start).format("YYYY-MM-DD"),
      });

      setTimeout(() => {
        setShouldOpenEditorDialog(true);
      }, 300);
      setOpenFormReserve(true);
  }
  // maxDayWeekEnd, mindayWeekEnd
  const handleFormSubmit = async () => {
    setLoading && setLoading(true);
    const res = await createBooking(isAdmin ? company : authInfo.companyId, {
      ...state,
    });

    if (res.result) {
      setLoading && setLoading(false);
      setSuccessMsg && setSuccessMsg(res.message);
      searchBookingByWeek(watchSubOptions);
    } else {
      setLoading && setLoading(false);
      setErrorMsg && setErrorMsg(res.message);
    }
    handleCloseFormReserve();
    setState({
      name: "",
      description: "",
      spaces: 0,
    });
  };

  const handleChange = (event: any) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
      lastName: "",
      email: "admin@bitcode-enterprise.com",
      phone: "87073898",
      totalAmount: completeData.publicAmount * (slotReserve.slots.length - 1),
      payMethod: "ADMIN",
      bookingDetailList: [
        {
          areaAmount:
            completeData.publicAmount * (slotReserve.slots.length - 1),
          idAreaDetail: watchSubOptions,
          totalHours: slotReserve.slots.length - 1,
          startTime: slotReserve.start,
          endTime: slotReserve.end,
          bookingDay: slotReserve.day,
          fullDay: false,
          spaces: completeData.hasCapacity
            ? parseInt(event.target.value)
            : null,
          status: 3,
        },
      ],
    });
  };

  // @ts-ignore
  const titleEvents = ({ description = "", allDay, status, start }) => {
    const formattedTime = localizer.format(start, "hh:mm A");
    if (allDay) {
      return `${t("allDay2")} : ${description} `;
    }
    if (status === 2) {
      return `${t("pendingApprove")} : ${formattedTime} ${description} `;
    }
    if (status === 3) {
      return `${t("approve")} : ${formattedTime} ${description} `;
    }
    return description;
  };

  const hadleShowEventClose = () => {
    setRejeEvent(showEvent);
    setShowEvent({ open: false, event: "" });
  };

  const handleSelectEvent = useCallback(
    // @ts-ignore
    (event) => {
      setDetailReserve(event);
      setShowEvent({ open: true, event });
    },
    [setShowEvent]
  );

  const slotPropGetter = useCallback(
    // @ts-ignore
    (date) => {
      if (minday.hour !== mindayWeekEnd.hours) {
        return {
          ...(moment(date).hour() >
            new Date(
              0,
              0,
              0,
              maxDayWeekEnd.hours,
              maxDayWeekEnd.minutes,
              0
            ).getHours() -
            1 &&
            (date.getDay() === 6 || date.getDay() === 0) && {
            style: {
              backgroundColor: "#ebebeb",
            },
          }),
          ...(moment(date).hour() <
            new Date(
              0,
              0,
              0,
              mindayWeekEnd.hours,
              maxDayWeekEnd.minutes,
              0
            ).getHours() &&
            (date.getDay() === 6 || date.getDay() === 0) && {
            style: {
              backgroundColor: "#ebebeb",
            },
          }),
        };
      }
    },
    [minday, maxDayWeekEnd, mindayWeekEnd]
  );

  const bookingApprovalHandler = async (
    id: number,
    status: boolean,
    message: string = t("reserveSuccessfullyApproved"),
    user = authInfo.username
  ) => {
    const data = {
      id,
      status,
      message,
      user,
    };

    // Toca hacerlo

    const res = await bookingApproval(isAdmin ? company : authInfo.companyId, [
      data,
    ]);

    if (res.result) {
      setSuccessMsg &&
        setSuccessMsg(
          status ? t("reserveSuccessfullyApproved") : t("reservationRejected")
        );
      if (watchSubOptions) {
        searchBookingByWeek(watchSubOptions);
      } else {
        searchAllBookingsByWeek();
      }
      setShowEvent({ open: false, event: "" });
    } else {
      setErrorMsg && setErrorMsg(t("errorWhenApprovingTheReservation"));
      setShowEvent({ open: false, event: "" });
    }
    handleCloseFormReserve();
    setState({
      name: "",
      description: "",
      spaces: 0,
    });
    setOpenModalReject(false);
  };

  return (
    <>
      {/* <img src={Banner} width="100%" /> */}
      <FancyPaper pagetitle={`${t("bookings")} / ${t("calendar")}`}>
        <Grid container spacing={8} sx={{ pb: 8 }}>
          <Grid item md={12} sm={12} xs={12}>
            {/* <ResourceAccess isCode={true} pathOrCode={'USER:WRITE'}> */}
            <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
              <FormControl>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={typeFilter}
                  onChange={(e) => {
                    setTypeFilter(e.target.value);
                  }}
                  sx={{
                    width: "200px",
                    paddingLeft: "15px",
                    "& .MuiInputBase-root": {
                      marginLeft: "10px",
                    },
                  }}
                >
                  {typeOptions &&
                    typeOptions.map((item: any, idx: number) => {
                      return (
                        <MenuItem value={item.id} key={idx}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
              <FormControl>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedCategory}
                  onChange={onChangeOptions}
                  displayEmpty
                  sx={{
                    width: "200px",
                    paddingLeft: "15px",
                    "& .MuiInputBase-root": {
                      marginLeft: "10px",
                    },
                  }}
                >
                  <MenuItem value="" disabled>
                    <em>{t("Categoría")}</em>
                  </MenuItem>
                  {options &&
                    options.map((item: any, idx: number) => {
                      return (
                        <MenuItem value={item.value} key={idx}>
                          {item.label}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
              {subOptions.length > 0 && (
                <Controller
                  control={control}
                  name="subOptions"
                  // defaultValue={subOptions[0].value}
                  render={({ field }) => (
                    <FormControl>
                      <Select
                        {...field}
                        value={field.value}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // label='Area'
                        // value={selectArea}
                        onChange={field.onChange}
                        sx={{
                          marginLeft: "10px",
                          width: "200px",
                          paddingLeft: "15px",
                          "& .MuiInputBase-root": {
                            // borderRadius: '0.2rem 0 0 0.2rem',
                            marginLeft: "10px",
                          },
                        }}
                      >
                          {subOptions &&
                          subOptions.map((item: any, idx: number) => {
                            return (
                              <MenuItem value={item.value} key={idx}>
                                {item.label}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  )}
                />
              )}
              {(selectedCategory || watchSubOptions) && (
                <Tooltip title={t("Limpiar filtros")}>
                  <IconButton
                    onClick={handleClearFilters}
                    size="small"
                    sx={{ ml: 1 }}
                  >
                    <FilterAltOffIcon />
                  </IconButton>
                </Tooltip>
              )}

              <Box display="flex" alignItems="center" gap={2}>
                <Box width="10px" height="10px" bgcolor="#0A3A7A" />
                <Typography>{t("externalReservations")}</Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={2}>
                <Box width="10px" height="10px" bgcolor="#01AEEF" />
                <Typography>{t("associateReservations")}</Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={2}>
                <Box width="10px" height="10px" bgcolor="#FFC000" />
                <Typography>{t("administratorReservations")}</Typography>
              </Box>
            </Box>

            {/* </ResourceAccess> */}
          </Grid>
        </Grid>
        {/* <TableContainer component={Paper}> */}
        {(watchSubOptions || allAreaDetails.length > 0) && (
          // @ts-ignore
          <Calendar
            localizer={localizer}
            events={eventos}
            step={30}
            timeslots={2}
            messages={lang}
            selectable="ignoreEvents"
            min={new Date(2022, 0, 0, minday.hour, minday.minutes, 0)}
            max={new Date(2022, 0, 0, maxDay.hours, maxDay.minutes, 0)}
            onSelectEvent={handleSelectEvent}
            onSelectSlot={handleSelectSlot}
            formats={formats}
            views={["week"]}
            defaultView={"week"}
            onNavigate={onNavigate}
            dayPropGetter={customDayPropGetter}
            eventPropGetter={eventPropGetter}
            slotPropGetter={slotPropGetter}
            titleAccessor={titleEvents}
            components={{ event: EventComponent }}
          // selectable={true}
          />
        )}

        {/* </TableContainer> */}
      </FancyPaper>
      {showEvent.open && (
        <Dialog onClose={hadleShowEventClose} open={showEvent.open}>
          <Box py={4} px={6}>
            <Typography align="center" variant="h4" mb={2}>
              {t("reservationDetails")}{" "}
            </Typography>
            <Typography variant="h6">
              <b>{t("idReservation")}:</b> {detailReserve.id}
            </Typography>
            <Typography variant="h6">
              <b>{t("reservation")}:</b> {detailReserve.description}
            </Typography>
            <Typography variant="h6">
              <b>{t("onBehalfOf")}:</b> {detailReserve.name}
            </Typography>
            <Typography variant="h6">
              <b>{t("state")}:</b>{" "}
              {detailReserve.status === 3 ? t("approved") : t("pendingApprove")}
            </Typography>
            {detailReserve.start && (
              <Typography variant="h6">
                <b>{t("start")}:</b>{" "}
                {moment(detailReserve.start).format("YYYY-MM-DD hh:mm A")}
              </Typography>
            )}
            {detailReserve.end &&
              !detailReserve.pickUpLocation &&
              !detailReserve.dropOffLocation && (
                <Typography variant="h6">
                  <b>{t("end")}:</b>{" "}
                  {moment(detailReserve.end).format("YYYY-MM-DD hh:mm A")}
                </Typography>
              )}
            {detailReserve.pickUpLocation && (
              <Typography variant="h6">
                <b>{t("pickUpLocation")}:</b> {detailReserve.pickUpLocation}
              </Typography>
            )}
            {detailReserve.dropOffLocation && (
              <Typography variant="h6">
                <b>{t("dropOffLocation")}:</b> {detailReserve.dropOffLocation}
              </Typography>
            )}
            {detailReserve.airline && (
              <Typography variant="h6">
                <b>{t("airline")}:</b> {detailReserve.airline}
              </Typography>
            )}
            {detailReserve.flightNumber && (
              <Typography variant="h6">
                <b>{t("flightNumber")}:</b> {detailReserve.flightNumber}
              </Typography>
            )}
            {detailReserve.arrivalTime && (
              <Typography variant="h6">
                <b>{t("arrivalTime")}:</b>{" "}
                {moment(detailReserve.arrivalTime, "HH:mm").format("hh:mm A")}
              </Typography>
            )}
            {detailReserve.spaces && (
              <Typography sx={{ mb: 2 }} variant="h6">
                <b>{t("reservedSpaces")}:</b> {detailReserve.spaces}
              </Typography>
            )}
            {detailReserve.stops.length > 0 && (
              <>
                <Divider />
                <Typography align="center" variant="h4" mb={2}>
                  {t("stops")}{" "}
                </Typography>
                {detailReserve.stops.map((stop: string, index: number) => (
                  <Typography sx={{ mb: 2 }} variant="h6" key={stop}>
                    <b>
                      {t("stop")} {index + 1}:
                    </b>{" "}
                    {stop}
                  </Typography>
                ))}
              </>
            )}

            {detailReserve.observations && (
              <>
                <Divider />
                <Typography align="center" variant="h4" mb={2}>
                  {t("observations")}{" "}
                </Typography>
                <Typography sx={{ mb: 2 }} variant="h6">
                  <b>{t("generalObservations")}:</b>{" "}
                  {detailReserve.observations}
                </Typography>
              </>
            )}

            <Divider />
            <Typography align="center" variant="h4" my={2}>
              {t("contact")}
            </Typography>
            <Typography variant="h6">
              {" "}
              <b>{t("email")}: </b>
              {detailReserve.email}
            </Typography>
            <Typography variant="h6">
              {" "}
              <b>{t("phone")}: </b>
              {detailReserve.phone}
            </Typography>
            <Box display={"flex"} justifyContent={"center"} mt={4} gap={2}>
              {detailReserve.status === 3 ? (
                <>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      // bookingApprovalHandler(detailReserve.id, false);
                      handleReject(detailReserve.id);
                    }}
                  >
                    {t("reject")}
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      // setDialogOpen(true)
                      hadleShowEventClose();
                    }}
                  >
                    {t("cancel")}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      // bookingApprovalHandler(detailReserve.id, false);
                      handleReject(detailReserve.id);
                    }}
                  >
                    {t("reject")}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    // onClick={handleClose}
                    onClick={() => {
                      bookingApprovalHandler(detailReserve.id, true);
                    }}
                  >
                    {t("approve")}
                  </Button>
                </>
              )}
            </Box>
          </Box>
        </Dialog>
      )}
      <Dialog onClose={handleCloseFormReserve} open={openFormReserve}>
        <Box p={3}>
          <Typography sx={{ mb: "10px" }} variant={"h5"}>
            {t("date")}: {slotReserve.date}{" "}
          </Typography>
          <Typography sx={{ mb: "20px" }} variant={"h5"}>
            {slotReserve.start &&
              slotReserve.end &&
              `${t("start")}: ${formatSingleHourTo12Hour(
                slotReserve.start
              )} ${t("end")}: ${formatSingleHourTo12Hour(slotReserve.end)}`}
          </Typography>

          <ValidatorForm onSubmit={(e) => { e.preventDefault(); handleFormSubmit(); }}>
            <Grid sx={{ mb: "16px" }} container spacing={{ xs: 2, sm: 4 }}>
              <Grid item sm={12} xs={12}>
                <TextField
                  label={`${t("name")}:`}
                  type="text"
                  name="name"
                  value={state?.name}
                  onChange={handleChange}
                  sx={{ py: 2, px: 2 }}
                />
              </Grid>
              <Grid item sm={12} xs={12}>
                <TextField
                  label={`${t("reservationReason")}:`}
                  type="text"
                  name="description"
                  value={state?.description}
                  onChange={handleChange}
                  sx={{ py: 2, px: 2 }}
                />
              </Grid>
              {completeData && completeData.hasCapacity && (
                <Grid item sm={12} xs={12}>
                  <TextField
                    label={`${t("spacesToReserve")}:`}
                    type="text"
                    name="spaces"
                    value={state?.spaces}
                    onChange={handleChange}
                    
                    sx={{ py: 2, px: 2 }}
                  />
                </Grid>
              )}
            </Grid>

            <FormHandlerBox>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: "20px" }}
                onClick={handleCloseFormReserve}
              >
                {t("cancel")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ marginRight: "20px" }}
              >
                {t("save")}
              </Button>
            </FormHandlerBox>
          </ValidatorForm>
        </Box>
      </Dialog>
      <RejectBookingModal
        openModalReject={openModalReject}
        handleCancelModalReject={() => {
          setOpenModalReject(false);
        }}
        onSubmit={async (data: any) => {
          bookingApprovalHandler(idReject, false, data.message);
        }}
        data={1}
      />
    </>
  );
};

export default CalendaryPage;
